import { render, staticRenderFns } from "./BioBubble.vue?vue&type=template&id=78d87590&scoped=true&"
import script from "./BioBubble.vue?vue&type=script&lang=js&"
export * from "./BioBubble.vue?vue&type=script&lang=js&"
import style0 from "./BioBubble.vue?vue&type=style&index=0&id=78d87590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d87590",
  null
  
)

export default component.exports